import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HerosectionHeader from "../../../../Componet/Herosection/HerosectionHeader";
import { Row, Col, Container, Table, Label, Input } from "reactstrap";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import SpinnerButton from "../../../../Componet/Button/SpinnerButton";
import { OrderTransactionData, CoversionMethodTypeData } from "../../../../store/Utility/Utility";
import { QuotationStepData } from "../../../../store/Utility/Utility";
import VehicleTypeIcon from "../../../../Componet/VehicleTypeIcon";
import moment from "moment";
import { OrderCancelationType, QuotationStatus, QuotationStep, ConversionMethodType } from "../../../../store/Utility/Status";
import EmptyDataResult from "../../../../Componet/EmptyDataResult";
import { useSpinner } from "../../../../context/SpinnerContext";
import Modal from "react-bootstrap/Modal";
import AutoCompleteInput from "../../../../Componet/Autocomplete/AutoCompleteInput";


const ConvertOrderInitialValue =
{
    paymentIntentId: null,
    description: null,
    show: false,
    header: null,
    message: null,
    isError: null,
    validationError: {},
    transferItem: '',
    selectedReason: '',
    description: null,
    error: null
}

const Transaction = () => {
    const [transaction, setTransaction] = useState([]);
    const [loading, setLoading] = useState(false);
    const axiosPrivate = useAxiosPrivate();
    const { showLoader, hideLoader } = useSpinner();
    const [convertOrderModal, setConvertOrderModal] = useState(ConvertOrderInitialValue);
    const [awaitingTransfer, setAwaitingTransfer] = useState();
    const navigate = useNavigate();

    const fetchTransactions = async () => {
       showLoader();
        await axiosPrivate.get(`v1/tenant/draft-orders`).then(res => {
            setTransaction(res.data.data);

        });
       hideLoader();
    };

    useEffect(() => {
        fetchTransactions();

    }, [])

    const onSearchClick = (e) => {
        if (loading) return;
        fetchTransactions();
    }

    const onNavigateOrder = (id) => {
        navigate(`/new-order`, {
            state: {
                orderid: id
            }
        });
    }

    return (
        <>
            <HerosectionHeader name={"Drafts"} />
            <div className="page-content">
                <section>
                    <Container>
                        <Row className="mb-2"><Col md={12}><span>Showing recent records only</span></Col></Row>
                        <Row>

                            <div className="col">
                                <div className="table-responsive table-bordered border-bottom-0" style={{ fontSize: "14px" }}>
                                    <Table className="cart-table table text-center mb-0" >
                                        <thead className="bg-light">
                                            <tr>
                                                <th scope="col">Vehicle</th>
                                                <th scope="col">Date (UTC)</th>
                                                <th scope="col">Contact</th>
                                                <th scope="col">Phone</th>
                                                <th scope="col">Vehicle Address</th>
                                                <th scope="col">Note</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {transaction.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="d-lg-flex align-items-center">
                                                            <VehicleTypeIcon vehicleType={item.vehicleType} width={40} />
                                                            <div className="ms-lg-3 mt-3 mt-lg-0">
                                                                <div
                                                                    // onClick={() =>
                                                                    //     navigate(`/product-single/${item.id}`)
                                                                    // }
                                                                    className="product-name"
                                                                >
                                                                    {/* {item.name} */}
                                                                    {item.make} / {item.model} / {item.year}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            {moment(item.createdDate).format('MM.DD.YYYY HH:mm')}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item.sellerContactName}

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item.sellerPhone}

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item.sellerAddress}

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item?.requesterNote}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <button className="btn btn-primary btn-sm" type="button" onClick={() => onNavigateOrder(item.id)} >
                                                                Make Payment
                                                            </button>
                                                            {/* <SpinnerButton type="button" className="btn btn-primary btn-sm" disabled={loading} loading={loading} onClick={() => onSendReminder(item.id)} text="Send Reminder" /> */}
                                                            <div className="dropdown">
                                                                {/* <button className="btn btn-secondary dropdown-toggle btn-sm" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    Actions
                                                                </button>
                                                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                                    <button className="dropdown-item" type="button" disabled={item.quotationStep != QuotationStep.Payment} onClick={() => { setConvertOrderModal({ ...convertOrderModal, show: true, orderNumber: item.orderNumber, id: item.id }) }}>Convert to Order</button>
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </Table>

                                </div>
                                {transaction.length == 0 && <div> <EmptyDataResult message="There is no data to display" /></div>}
                            </div>
                        </Row>
                    </Container>
                </section>
            </div>


        </>

    )
}

export default Transaction;